"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import { useEffect } from "react"
import Container from "ui/Container"
import { sharedColors } from "ui/theme/colors"
import { BreadCrumbs } from "utils"
import { decodeUnicodeEscapes } from "utils/decodeUnicodeEscapes"
import { formatTrafficDescription } from "utils/formatTrafficDescription"
import { TrafficUpdateSinglePage } from "utils/transformUpdate"
import TraffixBox from "../Homepage/TrafficUpdates/TraffixBox"
import Breadcrumbs from "../PeopleOfEgged/Breadcrumbs"

const BreadContainer = styled.div`
  width: 100%;
  padding-bottom: 24px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-bottom: 48px;
  }
`

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 40px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 48px;
    padding-bottom: 48px;
  }
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;

  padding-bottom: 48px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-bottom: 64px;
  }
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 24px;
  border-bottom: 1px solid ${sharedColors.borderGray};
`

const SectionTitle = styled(Typography)`
  font-size: 20px;
  font-weight: 700;
  color: ${sharedColors.black};
  padding-bottom: 16px;
`

const DescriptionText = styled(Typography)`
  u {
    text-decoration: underline;
  }
  strong {
    font-weight: 700;
  }
  p {
    margin: 16px 0;
  }
`

const formatDate = (dateString: string) => {
  const date = new Date(dateString)
  const day = date.getDate().toString().padStart(2, "0")
  const month = (date.getMonth() + 1).toString().padStart(2, "0")
  const year = date.getFullYear()
  const hours = date.getHours().toString().padStart(2, "0")
  const minutes = date.getMinutes().toString().padStart(2, "0")
  return `${hours}:${minutes} ${day}/${month}/${year}`
}

export default function TrafficIndividual({
  data,
  breadCrumbs,
  umbraco,
}: {
  data: TrafficUpdateSinglePage
  breadCrumbs: BreadCrumbs
  umbraco: boolean
}) {
  const t = useTranslations("Homepage")

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <BreadContainer>
        <Breadcrumbs breadCrumbs={breadCrumbs} />
      </BreadContainer>
      <Container paddingMobile={true}>
        <StyledContainer>
          <TraffixBox el={data} individual />
          <TextContainer>
            {data.itemsList?.map((el, i) => (
              <TextBox key={i}>
                <Typography variant="body1" fontWeight={700}>
                  {el.title}
                </Typography>
                <Typography
                  variant="body1"
                  dangerouslySetInnerHTML={{ __html: el.content }}
                />
              </TextBox>
            ))}
            {!umbraco && (
              <>
                <SectionTitle variant="h4">
                  {t("announcementDetails")}
                </SectionTitle>
                <TextBox>
                  <DescriptionText
                    variant="body1"
                    className="description"
                    dangerouslySetInnerHTML={{
                      __html: formatTrafficDescription(
                        decodeUnicodeEscapes(data.descriptionTextHe),
                      ),
                    }}
                  />
                </TextBox>
              </>
            )}
          </TextContainer>
        </StyledContainer>
      </Container>
    </>
  )
}
